// src/pages/Support/components/StatsCards.js

import React, { useMemo } from "react";
import { Card, Row, Col } from "antd";

const StatsCards = ({ tickets }) => {
  const stats = useMemo(
    () => ({
      new: tickets.filter((t) => t.status === "new").length,
      open: tickets.filter((t) => t.status === "opened").length,
      resolved: tickets.filter(
        (t) => t.status === "resolved" || t.status === "closed",
      ).length,
      closed: tickets.filter((t) => t.status === "closed").length,
      inProgress: tickets.filter((t) => t.status === "in_progress").length,
    }),
    [tickets],
  );

  const cardConfig = [
    {
      key: "new",
      title: "New Tickets",
      count: stats.new,
      icon: "/notification-status.png",
      color: "#1890ff",
    },
    {
      key: "open",
      title: "Open Tickets",
      count: stats.open,
      icon: "/note-text.png",
      color: "#fa8c16",
    },
    {
      key: "resolved",
      title: "Resolved Tickets",
      count: stats.resolved,
      icon: "/note-tick.png",
      color: "#52c41a",
    },
  ];

  return (
    <Row gutter={[20, 20]}>
      {cardConfig.map((card) => (
        <Col xs={24} sm={12} lg={8} key={card.key}>
          <Card
            hoverable
            style={{
              border: "none",
              borderRadius: 6,
              overflow: "hidden",
              position: "relative",
            }}
            bodyStyle={{
              padding: "28px 24px",
              textAlign: "center",
            }}>
            {/* Top accent line */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 3,
                backgroundColor: card.color,
              }}
            />

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                marginBottom: 12,
              }}>
              {/* Icon */}
              <img
                src={card.icon}
                alt={card.title}
                style={{
                  width: 24,
                  height: 24,
                  objectFit: "contain",
                  opacity: 0.9,
                }}
              />

              {/* Count */}
              <div
                style={{
                  fontSize: 28,
                  fontWeight: 600,
                  color: card.color,
                }}>
                {card.count}
              </div>
            </div>

            {/* Label */}
            <div
              style={{
                fontSize: 14,
                fontWeight: 400,
                color: "#666",
              }}>
              {card.title}
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StatsCards;
